import React from "react";

export default function ProgressBar({ current, total }) {
  const pct = Math.min(100, Math.max(0, (current / total) * 100));
  return (
    <div
      data-testid="quiz-progress-container"
      className="w-full"
      style={{ fontFamily: "Montserrat, sans-serif" }}
    >
      <div className="flex justify-between items-center mb-2">
        <span className="text-xs font-semibold text-[#001B33] uppercase tracking-wider">
          Step {current} of {total}
        </span>
        <span
          data-testid="quiz-progress-pct"
          className="text-xs font-semibold text-[#FF8800]"
        >
          {Math.round(pct)}%
        </span>
      </div>
      <div className="w-full bg-slate-200 rounded-full h-2 overflow-hidden">
        <div
          data-testid="quiz-progress-fill"
          className="bg-[#FF8800] h-2 rounded-full transition-all duration-500 ease-out"
          style={{ width: `${pct}%` }}
        />
      </div>
    </div>
  );
}
